// app_client/src/components/common/LocationPicker.jsx
import React, { useEffect } from 'react';
import { Globe, Building2, MapPin, Loader2 } from 'lucide-react';
import useLocationStore from '../../store/useLocationStore';

const LocationPicker = ({ selectedCountry, selectedCity, selectedDistrict, onChange }) => {
  const { 
    countries, cities, districts, 
    fetchCountries, fetchCities, fetchDistricts,
    loading 
  } = useLocationStore();

  // İlk yüklemede ülkeleri çek
  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  // Edit modu veya başlangıç verisi için hiyerarşiyi doldur
  useEffect(() => {
    if (selectedCountry) fetchCities(selectedCountry);
  }, [selectedCountry, fetchCities]);

  useEffect(() => {
    if (selectedCity) fetchDistricts(selectedCity);
  }, [selectedCity, fetchDistricts]);

  // Hiyerarşik değişim yönetimi
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    
    // Parent değişirse altındakileri temizlemesi için üst bileşene haber veriyoruz
    const updates = { [name]: value };
    
    if (name === 'country') {
      updates.city = '';
      updates.district = '';
    } else if (name === 'city') {
      updates.district = '';
    }

    // Üst bileşendeki handleChange'i tetikle
    Object.keys(updates).forEach(key => {
      onChange({ target: { name: key, value: updates[key] } });
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* ÜLKE */}
      <div className="space-y-1.5">
        <label className="text-[10px] font-black text-slate-500 uppercase ml-1 flex items-center gap-1">
          Ülke {loading.countries && <Loader2 size={10} className="animate-spin text-blue-500" />}
        </label>
        <div className="relative">
          <Globe size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <select name="country" value={selectedCountry || ''} onChange={handleSelectChange}
            className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold appearance-none focus:ring-2 ring-blue-500/10 outline-none">
            <option value="">Ülke Seçin</option>
            {countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
        </div>
      </div>

      {/* ŞEHİR */}
      <div className="space-y-1.5">
        <label className="text-[10px] font-black text-slate-500 uppercase ml-1 flex items-center gap-1">
          Şehir {loading.cities && <Loader2 size={10} className="animate-spin text-blue-500" />}
        </label>
        <div className="relative">
          <Building2 size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <select name="city" value={selectedCity || ''} onChange={handleSelectChange} disabled={!selectedCountry}
            className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold appearance-none disabled:opacity-50 focus:ring-2 ring-blue-500/10 outline-none">
            <option value="">Şehir Seçin</option>
            {cities.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
        </div>
      </div>

      {/* İLÇE / BÖLGE */}
      <div className="space-y-1.5">
        <label className="text-[10px] font-black text-slate-500 uppercase ml-1 flex items-center gap-1">
          İlçe / Bölge {loading.districts && <Loader2 size={10} className="animate-spin text-blue-500" />}
        </label>
        <div className="relative">
          <MapPin size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <select name="district" value={selectedDistrict || ''} onChange={handleSelectChange} disabled={!selectedCity}
            className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold appearance-none disabled:opacity-50 focus:ring-2 ring-blue-500/10 outline-none">
            <option value="">İlçe/Bölge Seçin</option>
            {districts.map(d => (
              <option key={d._id} value={d._id}>
                {d.name} {d.isCustomsPoint ? '(Gümrük)' : ''}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default LocationPicker;